import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
declare var ko: any;


export class grey_keywords_template extends vnTemplate{

    private pagination: pagination_template;
    private resultInfos: resultsInfo_template;
    protected filter: filterSimple_template;
    
    protected getTemplateName(): string {
        return "grey_keywords_template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected initPartial():void{

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateHtml(): string {
        return /* html */`
                    <div class="list-header w-justify" >

                    <div class="w-left" data-bind="if: isAddButtonShown">
                        <button data-bind="click: onClickShowPopUp" class="btn secondary icon i-add" type="button">Create Keyword</button>
                    </div>

                    <div class="w-center">
                        ${this.filter.getHtmlBuild()}
                    </div>

                    <div class="w-right">
                        <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                            <div class="pagination">
                                <input data-bind="value: pageNumber" type="hidden" value="1">
                                <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                                <ul data-bind="foreach: pages">
                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                                </ul>
                                <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="w-list-results" id="list-results">
                    <table class="list-results">
                       ${ this.resultInfos.getHtmlBuild() }
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'keyWord') }, css: { 'list-sort-desc': orderByAndDirection()=='keyWord_DESC', 'list-sort-asc': orderByAndDirection()=='keyWord_ASC' }">Keyword </span></th>

                            </tr>
                        </thead>
                        <tbody data-bind="foreach: fullGreyWordsList">

                            <tr>
                                <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: id"></span></td>
                                <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: keyWord"></span></td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div>   
                
                
            <div id="create-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">
                            
                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Create Keyword</h3>
                                <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                            </div>
                    
                            <div class="form-body">
                                <div class="form-group">
                                    <label class="form-label">keyword</label>
                                    <div class="w-input">
                                        <input type="text" name="keyword" id="keyword"  class="input-text" data-bind="value: keyword">
                                        <!--<strong class="form-sub-title">Brands</strong>
                                        <div  class="form-group">
                                            <legend class="form-legend"></legend>
                                            <div data-bind="foreach: brands">
                                                <div class="form-check-inline">
                                                    <input data-bind="value: id, checked: $parent.selectedBrands, attr:{id: 'brand_' + id}" type="checkbox">
                                                    <label class="form-label icon i-check" data-bind="click: $parent.onClickBrand, text: name, attr:{for: 'brand_' + id}"></label>
                                                </div>
                                            </div>
                                        </div>-->
                                    </div>
                                </div>
                            </div>
                    
                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                            </div>
                        </div>
                    
                    </div>
                </div>
        `
        ;
    }

    protected buildViewModel() {
        let huit_neuf_this = this;
        let viewModel = {
            fullGreyWordsList: ko.observableArray([]),
            isAddButtonShown: ko.observable(true),
            orderByAndDirection: ko.observable("id_ASC"),
            orderBy: ko.observable("id"),
            orderByDirection: ko.observable("ASC"),
            pages: ko.observableArray([]),
            idKeyword: ko.observable(0),
            keyword: ko.observable(""),
            brands: ko.observableArray([]),
            onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            },
            onClickSave: function () {
                huit_neuf_this.onClickSave();
            },
            onClickShowPopUp: function () {
                huit_neuf_this.onClickShowPopUp()
            },
            onClickHidePopUp: function () {
                huit_neuf_this.onClickHidePopUp()
            },
            onClickView: function (data, event) {
                huit_neuf_this.onClickView(data, event)
            }
            
        };
        return viewModel;
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.greyKeywordsReorder();
    }

    public onClickSave() {

        this.toggleDeleteDialogVisibility();
        this.caller.saveKeyword();
        this.getTemplateViewModel().keyword('');
        this.getTemplateViewModel().idKeyword(0);
    }

    public onClickShowPopUp() {

        this.toggleDeleteDialogVisibility();
    }

    public onClickHidePopUp() {

        this.toggleDeleteDialogVisibility();
        this.getTemplateViewModel().keyword('');
        this.getTemplateViewModel().idKeyword(0);
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('create-dialog').classList.toggle('is-visible');
        
    }

    public onClickView(data, event) {
        console.log(data);
        console.log(event);
        this.toggleDeleteDialogVisibility();
        this.getTemplateViewModel().keyword(data.keyWord);
        this.getTemplateViewModel().idKeyword(data.id);
    }

    public setFullGreyWordsList(fullGreyWordsList) {

        this.getTemplateViewModel().fullGreyWordsList(fullGreyWordsList);
    }

    public setBrandList(brandList) {
        this.getTemplateViewModel().brands(brandList);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/grey_keywords_template.ts